// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_iy-0";
export var fileCarousel = "_iy-2";
export var removeFileButton = "_iy-1";